import {
  AgreementType,
  ApplicationProductTypeEnum,
} from '@varo/graphql-schema-types';
import { useRouter } from 'expo-router';
import { agreementAtom } from 'features/payOverTime/store/payOverTimeOnboardingStore';
import { useOpenUrlDocumentScreen } from 'features/urlDocumentScreens/hooks/useOpenUrlDocumentScreen';
import UrlDocumentContext from 'features/urlDocumentScreens/UrlDocumentContext/UrlDocumentContext';
import { useAtomValue } from 'jotai';
import { useCallback, useContext } from 'react';
import { Linking } from 'react-native';
import { isWeb } from 'shared/constants/platform';
import useAgreements from 'shared/hooks/useAgreements/useAgreements';
import useGetDocument from 'shared/hooks/useGetDocument/useGetDocument';

const usePayOverTimeAgreementDocument = () => {
  const router = useRouter();
  const { setDocumentUrl } = useContext(UrlDocumentContext);
  const { openPdfDocumentScreen } = useOpenUrlDocumentScreen();
  const agreement = useAtomValue(agreementAtom);
  const { agreementsListDetails, loading } = useAgreements([
    ApplicationProductTypeEnum.PayOverTime,
  ]);
  const { documentDetails, fetching: isDocumentFetching } = useGetDocument(
    agreement?.documentId ?? '',
  );

  const termsAndConditionsDocumentUrl =
    agreementsListDetails?.find(
      (agreement) => agreement.type === AgreementType.PayOverTimeAgreement,
    )?.resource?.pdfDocument?.url ?? null;

  const truthInLendingDocumentUrl = documentDetails?.document?.url ?? null;

  const viewTermsAndConditionsDocument = useCallback(() => {
    const url = termsAndConditionsDocumentUrl;
    if (url) {
      openPdfDocumentScreen(url);
    }
  }, [openPdfDocumentScreen, termsAndConditionsDocumentUrl]);

  const viewTruthInLendingDocument = useCallback(() => {
    if (!truthInLendingDocumentUrl) {
      return;
    }

    if (isWeb) {
      void Linking.openURL(truthInLendingDocumentUrl);
      return;
    }

    setDocumentUrl?.(truthInLendingDocumentUrl);
    router.push('/pay-over-time/truth-in-lending');
  }, [router, setDocumentUrl, truthInLendingDocumentUrl]);

  return {
    viewTermsAndConditionsDocument,
    viewTruthInLendingDocument,
    fetching: loading || isDocumentFetching,
    termsAndConditionsDocumentUrl,
    truthInLendingDocumentUrl,
  };
};

export default usePayOverTimeAgreementDocument;
